import { HANDLE_INFORMATION } from '../actions';
import moment from 'moment';

const initialState = {  
    information: [],
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    manager: "",
    status: [4],
    pageNo: 1,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case HANDLE_INFORMATION:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  } 
}
